import Vue from "vue";

const END_POINT = "/gamings";

const getUserBreaches = () => Vue.axios.get(`${END_POINT}/user/breaches`);
const getBreach = id => Vue.axios.get(`${END_POINT}/breaches/${id}`);
const updateBreach = (stakeholderId, surveyEntityId, breachId) =>
  Vue.axios.put(
    `${END_POINT}/${stakeholderId}/${surveyEntityId}/${breachId}/true`
  );

export { getUserBreaches, getBreach, updateBreach };
